module.exports = __webpack_public_path__ + "static/media/cairo-regular.884284b4.woff";